import { ajaxRetry } from '../ajaxRetry';

import { RefreshableItem } from '../../models/refreshableItem';
import { base, createApiURL, ResponseObj } from './base';

export type ScopeItem = {
  title: string | JSX.Element;
  description: string | JSX.Element;
};

export type OauthDescribeSuccessResponse = {
  clientIconUrl: string;
  clientName: string;
  clientUrl: string;
  embeddedAllowed: boolean;
  scopesDescriptionsList: ScopeItem[];
  verified: boolean;
  aggregator: boolean;
};

export enum OauthErrorCode {
  INVALID_SCOPE = 'oauth.invalid_scope',
  INVALID_REDIRECT_URI = 'oauth.invalid_redirect_uri',
}

export type OauthDescribeErrorResponse = {
  errorMessage?: string;
  errorCode?: OauthErrorCode;
};

type AuthorizeResponse = {
  code: string;
};

export type AuthorizePayload = {
  clientId?: string;
  redirectUri?: string;
  state?: string;
  scope?: string;
};

export const authorize = async (
  oauthParameters: AuthorizePayload
): Promise<ResponseObj<AuthorizeResponse>> => {
  return ajaxRetry<AuthorizeResponse>({
    data: JSON.stringify(oauthParameters),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL('/api/v1/oauth/authorize'),
  });
};

export type DescribeRequest = {
  clientId?: string;
  redirectUri?: string;
  scope?: string;
  state?: string;
  refreshItems?: RefreshableItem[];
};

export const describeClientApp = (
  request: DescribeRequest
): Promise<ResponseObj<OauthDescribeSuccessResponse> | ResponseObj<OauthDescribeErrorResponse>> => {
  return ajaxRetry<OauthDescribeSuccessResponse, OauthDescribeErrorResponse>({
    data: JSON.stringify(request),
    headers: base.headers(),
    method: 'POST',
    url: createApiURL('/api/v1/oauth/describe'),
  });
};
